class VwSonucizlememuracaatDTO {
    id: number = 0;
    kimlikId?: number = null;
    kimlikNo?: string = "";
    muracaatId?: number = null;
    tarih?: string = null;
    kabulredtarih?: string = null;
    onayTarih?: string = null;
    adi?: string = "";
    soyadi?: string = "";
    dogumTarihi?: string = null;
    aileAdi?: string = "";
    istemAdi?: string = "";
    entAciklama?: string = "";
    entLisbarkodno?: number = null;
    entLisornekno?: number = null;
    labGonTarih?: string = null;
    kalantoplam?: number = null;
    ucrethastakarsilar?: string = "";
    organizasyonId?: number = null;
    entDisLisbarkodno?: string = "";
    borc?: number = null;
    searchText?: string = "";
    kurumgrupId?: number = null;
    orgtreekey?: string = "";
    kurumId?: number = null;
    hastaraporId?: number = null;
    testGrupId?: number = null;
    servisAdi?: string = "";
    raporIndirmeTarih?: string = null;
    raporIndirmeKullanici?: number = null;
    patolojiDurum?: number = null;
    laboratuvarDurum?: number = null;
    entProtokolno?: string = null;
};
export default VwSonucizlememuracaatDTO;